"use strict";
/**
 * Created on 02 06 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var PromotionProduct_1 = require("../model/PromotionProduct");

var PromotionProductConverter_1 = require("./PromotionProductConverter");
/**
 * <p>Implementation of {@link PromotionProductConverter}.</p>
 *
 * @author JMe
 */


var PromotionProductConverterImpl =
/*#__PURE__*/
function (_PromotionProductConv) {
  _inherits(PromotionProductConverterImpl, _PromotionProductConv);

  function PromotionProductConverterImpl() {
    _classCallCheck(this, PromotionProductConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionProductConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionProductConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: conversions.toDocumentReferenceId(source.productId),
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo),
        priceValue: conversions.fromBigNumber(source.priceValue),
        pricePriority: source.pricePriority,
        workflowState: source.workflowState,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        parentGroupOfSitesId: conversions.toDocumentReferenceId(source.parentGroupOfSitesId),
        parentValidFrom: conversions.fromDate(source.parentValidFrom),
        parentValidTo: conversions.fromDate(source.parentValidTo),
        sites: conversions.asObjectArray(source, 'sites', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        stateFlags: source.stateFlags.serialize(),
        returnPossibility: source.returnPossibility,
        processed: source.processed
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromotionProduct_1.PromotionProduct(conversions.documentToClassId(source), PromotionProduct_1.PromotionProduct.schema.externalId.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PromotionProduct_1.PromotionProduct.schema.groupOfSitesId.valueOf(conversions.toClassReferenceId(source.groupOfSitesId)), PromotionProduct_1.PromotionProduct.schema.validFrom.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.validTo.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.priceValue.valueOf(conversions.toBigNumber(source.priceValue)), PromotionProduct_1.PromotionProduct.schema.pricePriority.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.workflowState.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), PromotionProduct_1.PromotionProduct.schema.parentGroupOfSitesId.valueOf(conversions.toClassReferenceId(source.parentGroupOfSitesId)), PromotionProduct_1.PromotionProduct.schema.parentValidFrom.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.parentValidTo.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.sites.valueOf(conversions.asClassReferenceIdsSet(source, 'sites')), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), PromotionProduct_1.PromotionProduct.schema.returnPossibility.valueOfField(source), PromotionProduct_1.PromotionProduct.schema.processed.valueOfField(source));
    }
  }]);

  return PromotionProductConverterImpl;
}(PromotionProductConverter_1.PromotionProductConverter);

exports.PromotionProductConverterImpl = PromotionProductConverterImpl;